import React from "react";
import { CareRecipientsTableBody } from "./CareRecipientsTableBody";
import { CareRecipientsTableHead } from "./CareRecipientsTableHead";

export const CareRecipientsTable = React.memo(function CareRecipientsTable() {
    return (
        <table className={"recipient_list"}>
            <CareRecipientsTableHead />
            <CareRecipientsTableBody />
        </table>
    );
});
